import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce, get } from 'lodash';
import uuid from 'uuid/v4';
import { getFormInitialValues } from 'redux-form';

import TriggerFieldsBySlots from
  '../../../components/purchase-dashboard/autopilot/trigger-fields.by-slots';
import TriggerFieldsSPP from
  '../../../components/purchase-dashboard/autopilot/trigger-fields.spp';
import Purchase from '../../../lib/purchase';
import {
  getCurrentPurchase,
  findCurrentUserMembership,
} from '../../../selectors/purchase-selector';
import {
  projectPurchase,
  AUTOPILOT_NAMESPACE,
} from '../../../actions';
import {
  FORM_NAME,
} from '../../../components/purchase-dashboard/autopilot/index';

class TriggerFieldsContainer extends Component {
  constructor(props) {
    super(props);
    this.debouncedProjectPurchase = debounce(this.props.projectPurchase, 500, { maxWait: 2000 });
    this.onTriggerSlotsChange = this.onTriggerSlotsChange.bind(this);
    this.projectedMembershipId = uuid();
    this.state = { autoPilotTriggerSlots: this.props.initialValues.autoPilotTriggerSlots };
  }

  componentWillMount() {
    this.fetchProjection();
  }

  onTriggerSlotsChange(autoPilotTriggerSlots) {
    this.setState({ autoPilotTriggerSlots });
    this.fetchProjection();
  }

  fetchProjection() {
    const { purchase, currentMembership } = this.props;
    const claimedSlots = this.state.autoPilotTriggerSlots - purchase.committedSlots;

    if (claimedSlots < 1) {

      return this.debouncedProjectPurchase({
        id: purchase.id,
        memberships: [{
          id: currentMembership.id,
          claimedSlots: currentMembership.claimedSlots,
        }],
      }, AUTOPILOT_NAMESPACE);
    };

    const data = {
      id: purchase.id,
      memberships: [
        {
          id: this.projectedMembershipId,
          claimedSlots,
        },
      ],
    };

    this.debouncedProjectPurchase(data, AUTOPILOT_NAMESPACE);
  }

  render() {
    const { amount, maxSlots, minSlots, splitType, productMinSlots, purchase } = this.props;
    if (Purchase.isSpecifiedPerPerson(splitType) && get(purchase, 'product.costs', []).length <= 1) {
      return (
        <TriggerFieldsSPP
          amount={amount}
          minSlots={productMinSlots}
          purchase={purchase}
        />
      );
    }

    return (
      <TriggerFieldsBySlots
        maxSlots={maxSlots}
        minSlots={minSlots}
        onTriggerSlotsChange={this.onTriggerSlotsChange}
        purchase={purchase}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const initialValues = getFormInitialValues(FORM_NAME)(state);

  return {
    purchase,
    currentMembership: findCurrentUserMembership(state),
    amount: purchase.currentTotalCostAmount,
    maxSlots: purchase.group.maxSlots,
    minSlots: purchase.committedSlots + 1,
    splitType: purchase.group.splitType,
    productMinSlots: purchase.product.minSlots,
    initialValues,
  };
};

const mapDispatchToProps = {
  projectPurchase,
};

export default connect(mapStateToProps, mapDispatchToProps)(TriggerFieldsContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/autopilot/trigger-fields.container.js